/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.deviceModel', [])
    .factory('deviceModelService', DeviceModelService)
    .name;

/*@ngInject*/
function DeviceModelService($http, $q) {

    var service = {
        deleteDeviceModel: deleteDeviceModel,
        getDeviceModel: getDeviceModel,
        getSystemDeviceModel: getSystemDeviceModel,
        saveDeviceModel: saveDeviceModel,
        getCustomerDeviceModels: getCustomerDeviceModels
    }

    return service;

    function getCustomerDeviceModels () {
        var deferred = $q.defer();
        $http.get('/api/customer/deviceModels', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDeviceModel (deviceModelId) {
        var deferred = $q.defer();
        var url = '/api/deviceModel/' + deviceModelId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSystemDeviceModel (deviceModelId) {
        var deferred = $q.defer();
        var url = '/api/system/deviceModel/' + deviceModelId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveDeviceModel (deviceModel) {
        var deferred = $q.defer();
        var url = '/api/deviceModel';
        $http.post(url, deviceModel).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteDeviceModel (deviceModelId) {
        var deferred = $q.defer();
        var url = '/api/deviceModel/' + deviceModelId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/device-model.service.js